const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-mail/tpl.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { MailTplFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-mail/tpl-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-mail/tpl')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: MailTplFilterParamSchema
});